var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapSwitchFullHotWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.002,
    height: 69,
    viewBox: "0 0 202.002 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full-Hot_Water",
    "data-name": "Full-Hot Water",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4309",
    "data-name": "Rectangle 4309",
    width: 202,
    height: 69,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M86.23,68.35c-.09,0-.13-.01-79.38-12.43A7.02,7.02,0,0,1,.92,49.1L.65,9.97A4.152,4.152,0,0,1,1.83,6.99,4.084,4.084,0,0,1,4.77,5.75h.6c56.14-.06,101.63-.1,135.23-.1,29.05,0,47.77.03,55.63.08a4.767,4.767,0,0,1,4.75,4.75l.37,53.37a4.439,4.439,0,0,1-4.44,4.49H86.23Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M86.2,67.67c-.05,0-79.14-12.38-79.14-12.38-3.61-.3-5.44-3-5.5-6.11L1.3,10.43A3.851,3.851,0,0,1,4.9,6.56c24.96-.03,164.94-.1,191.52.08a3.973,3.973,0,0,1,3.88,4.15l.4,53.14c.03,2.12-1.15,3.78-3.55,3.78Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M.72,19.66.92,49.1a7.02,7.02,0,0,0,5.93,6.82C86.1,68.34,86.14,68.34,86.23,68.35H196.92a4.439,4.439,0,0,0,4.44-4.49l-.32-46.21c-4.98-4.07-9.75.63-9.75.63s-6.8,5.85-12.73,0-10.99,0-10.99,0-6.45,6.19-12.73,0-11.86,0-11.86,0-5.84,7.6-12.55.98c-6.05-5.97-11.55-1.18-12.58-.17v-.05s-6.28,5.16-11.52,0-10.46,0-10.46,0-6.8,5.85-12.73,0-10.99,0-10.99,0-6.45,6.19-12.73,0-11.86,0-11.86,0-5.84,7.6-12.55.98c-5.94-5.86-11.34-1.36-12.51-.24-1.9,1.19-6.59,3.41-10.65-.6-5.23-5.16-10.46,0-10.46,0S1.13,19.38.72,19.66Z",
    fill: "#ff001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M140.53,6.3c25.53,0,46.9.02,55.7.08a4.132,4.132,0,0,1,4.1,4.1l.37,53.37a3.784,3.784,0,0,1-3.78,3.84H86.23c-.05,0-79.28-12.42-79.28-12.42a6.385,6.385,0,0,1-5.38-6.19L1.3,9.96A3.485,3.485,0,0,1,4.77,6.4c16.58-.02,84.53-.1,135.76-.1m0-1.3c-23.15,0-65.41.02-135.28.1H4.77A4.735,4.735,0,0,0,1.36,6.54,4.792,4.792,0,0,0,0,9.99L.27,49.1a7.686,7.686,0,0,0,6.48,7.47C86.03,68.99,86.06,68.99,86.13,69H196.92A5.088,5.088,0,0,0,202,63.84l-.37-53.36a5.414,5.414,0,0,0-5.39-5.4C188.37,5.03,169.62,5,140.53,5Z",
    fill: "#808184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapSwitchFullHotWater);
export default __webpack_public_path__ + "static/media/air_gap_switch_full_hot_water.7e6de2b33355e2dca0c309e6154edc82.svg";
export { ForwardRef as ReactComponent };